export default {
    data: {
        mediaLibraryIsOpened: false,
        mediaEditorIsOpened: false,
        mediaContext: '',
        modelType: '',
        modelId: '',
        siteHashid: '',
        mediaLibrarySupportedTypes: [],
        mediaLibraryMultiupload: false,
        mediaLibraryActiveTab: '',
        currentEditorMedium: null,
        media: [],
        axiosEndpoint: '/admin/ajax',
        uploadingMedia: {}
    },

    created() {
        const busListeners = this.$options.busListeners(this);
        for (let methodName in busListeners) {
            this.$bus.$on(methodName, busListeners[methodName]);
        }

        // register custom listeners
    },

    methods: {
        findMedium(id) {
            let index = this.media.findIndex(function(obj) {
                return obj.id == id;
            });
            if (index != -1) {
                return this.media[index];
            }
            return false;
        },

        addMedia(media) {
            this.media = this.media.concat(media);
        },

        updateMedium(medium) {
            let index = this.media.findIndex(function(obj) {
                return obj.id == medium.id;
            });
            if (index != -1) {
               this.media[index] = medium;
            }
        },

        deleteMedium(medium) {
            let found = this.findMedium(medium.id);
            if (found) {
                this.media.splice(this.media.indexOf(found), 1);
            }
        },

        mediaByContext(context) {
            return this.media.filter(function(obj) {
                return obj.context == context;
            });
        },

        firstMedium(context) {
            let mediaByContext = this.mediaByContext(context);
            if (mediaByContext.length == 0) return null;

            // return last added item
            return mediaByContext[mediaByContext.length - 1];
        },

        mediaProgressBarValue(context) {
            const initial = 100 - 50 / this.uploadingMedia[context].total;
            return Math.ceil(100 - initial * this.uploadingMedia[context].remaining / this.uploadingMedia[context].total);
        }
    },

    busListeners: (vm) => ({
        openMediaLibrary(config, context) {
            vm.mediaContext = context;

            if (config.hasOwnProperty('supportedMediaTypes')) {
                vm.mediaLibrarySupportedTypes = config.supportedMediaTypes;
            }

            if (config.hasOwnProperty('multiupload')) {
                vm.mediaLibraryMultiupload = config.multiupload;
            }

            if (config.hasOwnProperty('activeTab')) {
                vm.mediaLibraryActiveTab = config.activeTab;
            }

            vm.mediaLibraryIsOpened = true;
        },
        closeMediaLibrary() {
            vm.mediaLibraryIsOpened = false;
            vm.mediaLibraryActiveTab = '';
        },
        openMediaEditor(medium) {
            vm.currentEditorMedium = medium;
            vm.mediaEditorIsOpened = true;
        },
        closeMediaEditor() {
            vm.mediaEditorIsOpened = false;
            vm.currentEditorMedium = null;
        },
        setMediaContext(context) {
            vm.mediaContext = context;
        }
    })
};
